import React from "react";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../i18n/localizationKeys";
import * as PropTypes from "prop-types";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ENGINE_POSITION } from "../../constants/trendGraph/enginesLine.js";

const label = {
  fontFamily: "Inter",
  fontSize: "14px",
  fontWeight: "500",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  color: "#19b2ab",
};

const styles = {
  paperHeightEngine: {
    position: "relative",
    marginBottom: "16px",
  },
  engineSelectorContainer: {
    display: "flex",
    justifyContent: "center",
    "& p": {
      ...label,
    },
  },
  radio: {
    color: "#19b2ab !important",
  },
  typographyLabel: {
    marginLeft: "20px",
    color: "#FFFFFF",
    fontFamily: "Inter",
    "& .MuiTypography-body1": {
      fontSize: "12px !important",
    },
  },
  radioLabel: {
    color: "#FFFFFF",
    fontFamily: "Inter",
    "& .MuiTypography-body1": {
      fontSize: "10px !important",
    },
  },
};

export const EngineSelector = React.memo(
  ({
    currentVessel,
    selectedEngine = '',
    setSelectedEngine = null,
  }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));

    const engineSelect = (e, position) => {
      setSelectedEngine(position);
    };

    const engineList = [
      {
        position: ENGINE_POSITION.PORT,
        label: localizationKeys.PortEngine,
      },
      {
        position: ENGINE_POSITION.CENTER,
        label: localizationKeys.Engine_upper,
      },
      {
        position: ENGINE_POSITION.STARBOARD,
        label: localizationKeys.StarboardEngine,
      },
    ];

    const getEngines = (noME) => {
      let index = [];
      switch (noME) {
        case 3:
          index = [0, 1, 2];
          break;
        case 2:
          index = [0, 2];
          break;
        default:
          index = [1];
      }
      return engineList.filter((e, i) => index.includes(i));
    };

    const EngineRadio = () => {
      return (
          <Grid
            item
            size={{ sm: 8, md: 12 }}
            container
            direction="row"
            sx={{
              justifyContent: isSmall ? "left" : "center",
              display: "flex",
            }}
          >
            <RadioGroup
              name="engine-select-radio-group"
              defaultValue={
                currentVessel?.NoME === 1 ? ENGINE_POSITION.CENTER : ENGINE_POSITION.PORT
              }
              value={selectedEngine}
              onChange={(e) => engineSelect(e, e.target.value)}
              row={true}
            >
              {(() => {
                return getEngines(currentVessel?.NoME).map((d, i) => {
                  if (currentVessel?.NoME <= 1) {
                    return (
                      <></>
                    );
                  } else {
                    return (
                      <FormControlLabel
                        key={`engine-radio-${i}`}
                        control={<Radio sx={styles.radio} />}
                        label={`${t(d.label)}`}
                        value={d.position}
                        sx={styles.radioLabel}
                      />
                    );
                  }
                });
              })()}
            </RadioGroup>
          </Grid>
      );
    };

    return (
        <Grid
          id="Controller"
          container
          spacing={2}
          direction={"row"}
          alignItems={isSmall ? "center" : null}
          justifyContent={isXs ? "center" : null}
        >
          <EngineRadio />
        </Grid>
    );
  }
);

EngineSelector.propTypes = {
  currentVessel: PropTypes.object,
  selectedEngine: PropTypes.string,
  setSelectedEngine: PropTypes.func,
};